import { z } from "zod";
import { dmaPhaseDtoSchema } from "./dma-phase.schema";
import { dmaSpaceKindDtoSchema } from "./dma-space-kind.schema";
export const dmaSpaceDtoSchema = z.object({
    kind: z.union([dmaPhaseDtoSchema, dmaSpaceKindDtoSchema]),
    spaceId: z.number(),
});
